import { RoleEnum } from '@zeus/index'

/**
 * Les rôles d'encadrement : ceux qui ouvrent le back-office et peuvent animer un
 * parcours (#244). Même liste que `STAFF_ROLES` côté API.
 */
export const STAFF_ROLES: readonly RoleEnum[] = [RoleEnum.Admin, RoleEnum.Formateur]
